import ShowDetailImage from './ShowDetailImage'

export default ShowDetailImage
